import { ReactNode, useCallback, useEffect, useState } from "react"
import {
  LinkExit,
  LinkSuccess,
  dismissLink,
} from "../ReactNativePlaidLinkSDK/ReactNativePlaidLinkSDK"
import { usePlaidLink } from "../../hooks"
import { Platform, Pressable } from "react-native"
import { Sentry } from "../../utils/Sentry"

export const PlaidLink = (props: {
  linkToken: string
  onSuccess: (success: LinkSuccess) => void
  onExit: (response: LinkExit) => void
  children?: ReactNode
  launchOnMount?: boolean
  onStart?: () => void
}) => {
  const { linkToken, onStart, onExit, onSuccess, launchOnMount, children } = props
  const [alreadyLaunchedOnMount, setAlreadyLaunchedOnMount] = useState(false)

  const { startLink } = usePlaidLink({
    token: linkToken,
    onSuccess: (success) => {
      Sentry.captureMessage("PlaidLink - Success", { extra: { level: "info", success } })
      onSuccess(success)
      if (Platform.OS === "ios") {
        dismissLink()
      }
    },
    onExit: (exit) => {
      Sentry.captureMessage("PlaidLink - Exit", { extra: { level: "info", error: exit } })
      onExit(exit)
      if (Platform.OS === "ios") {
        dismissLink()
      }
    },
  })

  const linkHandle = useCallback(() => {
    if (onStart) {
      onStart()
    }
    Sentry.captureMessage("PlaidLink - Start", { extra: { level: "info", linkToken: linkToken } })
    startLink()
  }, [onStart, linkToken, startLink])

  useEffect(() => {
    if (launchOnMount && !alreadyLaunchedOnMount) {
      linkHandle()
      setTimeout(() => setAlreadyLaunchedOnMount(true), 1000)
    }
  }, [launchOnMount, linkHandle, alreadyLaunchedOnMount])

  return <Pressable onPress={linkHandle}>{children}</Pressable>
}
